import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import type { ReportBlock } from "./reporting.service";
import BlockRenderer from "./blocks/BlockRenderer";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  blocks: ReportBlock[];
  sourceLabelFor?: (block: ReportBlock) => string | null;
}

const PreviewModal: React.FC<Props> = ({
  open,
  onClose,
  title,
  subtitle,
  blocks,
  sourceLabelFor,
}) => {
  const { t } = useTranslation("reporting");
  const defaultSubtitle = subtitle ?? t("previewModal.customReport");
  const ordered = [...blocks].sort((a, b) => a.order - b.order);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={760}
      closeIcon={<span className="rb-preview__close">×</span>}
      className="rb-preview-modal"
      styles={{ body: { padding: 0 } }}
    >
      <div className="rb-preview__header">
        <h2>{title}</h2>
        <span>{defaultSubtitle}</span>
      </div>
      <div className="rb-preview__body">
        {ordered.map((b) => (
          <BlockRenderer
            key={b.id}
            block={b}
            mode="preview"
            sourceLabel={sourceLabelFor?.(b) ?? null}
          />
        ))}
      </div>
    </Modal>
  );
};

export default PreviewModal;
